import VueI18n from 'vue-i18n/dist/vue-i18n'  // 修改导入路径
import Vue from 'vue'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
let zh = require('./zh_cn.js')
let en = require('./en.js')

Vue.use(VueI18n)

const i18n = new VueI18n({
	locale: 'zh',
	messages: {
		zh: { ...zhLocale, ...zh },
    en: { ...enLocale, ...en }
	}
});

Vue.prototype.i18n = i18n;

export default i18n;
